﻿import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DateTimeView from '../../../../../localDate/DateTimeView';
import { LocalDateTime } from '../../../../../localDate/DateTimeView';

type SentFilmInformationLabels = {
    sentTo: string;
};

type SentFilmInformationProps = {
    labels: SentFilmInformationLabels;
    sentToEmail: string;
    emailSentTime: Date;
};

function SentFilmInformation({ labels, sentToEmail, emailSentTime }: SentFilmInformationProps) {
    const dateTime: LocalDateTime = {
        localDateTime: emailSentTime
    };

    return (
        <Box sx={{ padding: '14px 16px' }}>
            <Typography
                variant="body1"
                sx={{ fontSize: '12px ' }}
            >{`${labels.sentTo} ${sentToEmail}`}</Typography>
            <Typography variant="body1" sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}>
                <DateTimeView dateTime={dateTime} />
            </Typography>
        </Box>
    );
}

export default SentFilmInformation;
